import Photos from './Photos';

export default function Packages({ id, order }) {
  const packages = order?.packages || [];

  return (
    <div
      id={id}
      className="packages"
      role="region"
      aria-label="Содержимое заказа"
    >
      <main className="package-table-scroll">
        <table className="packages package-table">
          <tbody>
            {packages.map(pkg => (
              <tr key={pkg.id}>
                <td>
                  <Photos title={pkg.title} photos={pkg.photos} />
                </td>
                <td className="caption">{pkg.title}</td>
                <td className="right">{pkg.price}</td>
                <td className="right">{pkg.weight}</td>
                <td className="center">
                  <span className={`label label-${pkg.statusColor}`}>
                    {pkg.status}
                  </span>
                </td>
                <td className="center">
                  <span className={`label label-${pkg.paymentStatusColor}`}>
                    {pkg.paymentStatus}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </main>
      <div className="package-cards">
        {packages.map(pkg => (
          <article
            key={pkg.id}
            className="package-card"
            aria-label={`Посылка: ${pkg.title}`}
          >
            <div className="package-card-media">
              <Photos title={pkg.title} photos={pkg.photos} />
            </div>
            <div className="package-card-body">
              <h4>{pkg.title}</h4>
              <dl className="package-card-metrics">
                <div>
                  <dt>Стоимость</dt>
                  <dd>{pkg.price}</dd>
                </div>
                <div>
                  <dt>Вес</dt>
                  <dd>{pkg.weight}</dd>
                </div>
              </dl>
              <div className="package-card-statuses">
                {pkg.status ? (
                  <span className={`label label-${pkg.statusColor}`}>
                    {pkg.status}
                  </span>
                ) : null}
                {pkg.paymentStatus ? (
                  <span className={`label label-${pkg.paymentStatusColor}`}>
                    {pkg.paymentStatus}
                  </span>
                ) : null}
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
